import { render, staticRenderFns } from "./avatar-link.vue?vue&type=template&id=527d94fe&"
import script from "./avatar-link.vue?vue&type=script&lang=js&"
export * from "./avatar-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports